import { useTranslation } from "next-i18next"

const useShopTheRoomDetailsi18n = () => {
  const { t } = useTranslation()
  const i18n = {
    twoItemAvailable: t("kf.shopTheRoom.label.twoItemAvailable"),
    noItemAvailable: t("kf.shopTheRoom.label.noItemAvailable"),
    productsLabel: t("kf.compare.label.products"),
    discontinued: t("kf.shopTheRoom.label.discontinued"),
    addToCart: t("kf.compare.label.addToCart"),
    outOfStock: t("kf.curated.label.outOfStock"),
    availColorCTA: t("kf.pdp.label.availColorCTA"),
    notifyMailCTA: t("kf.pdp.label.notifyMailCTA"),
    changeQuantity: t("kf.shopTheRoom.label.changeQuantity"),
  }
  return i18n
}
export default useShopTheRoomDetailsi18n
